export const ACCEPTED_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
export const ACCEPTED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"] as const;
export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100MB

interface FileLike {
  size: number;
  type: string;
  name?: string;
}

export class RemoveBgValidationError extends Error {
  constructor(public readonly code: string, message: string, public readonly details?: Record<string, unknown>) {
    super(message);
    this.name = "RemoveBgValidationError";
  }
}

export function validateFileType(mimeType: string) {
  if (!ACCEPTED_MIME_TYPES.includes(mimeType as (typeof ACCEPTED_MIME_TYPES)[number])) {
    throw new RemoveBgValidationError("REMOVE_BG.INVALID_FILE", "Formato não suportado. Envie PNG, JPG ou WEBP.", {
      accepted_mimes: ACCEPTED_MIME_TYPES,
      received_mime: mimeType
    });
  }
}

export function validateFileSize(size: number) {
  if (size > MAX_FILE_SIZE_BYTES) {
    throw new RemoveBgValidationError("REMOVE_BG.FILE_TOO_BIG", "Arquivo excede 100MB. Escolha uma imagem menor.", {
      max_bytes: MAX_FILE_SIZE_BYTES,
      size_bytes: size
    });
  }
}

export function validateImageFile(file: FileLike) {
  validateFileType(file.type);
  validateFileSize(file.size);
}

export function getExtensionFromMime(mimeType: string): string {
  switch (mimeType) {
    case "image/jpeg":
      return ".jpg";
    case "image/png":
      return ".png";
    case "image/webp":
      return ".webp";
    default:
      return "";
  }
}

export function sanitizeFilename(originalName: string): string {
  const nameWithoutPath = originalName.replace(/\\|\//g, "_");
  const normalized = nameWithoutPath
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]/g, "-")
    .replace(/-+/g, "-")
    .toLowerCase();
  return normalized.substring(0, 100);
}

export function formatBytes(size: number): string {
  if (size === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const exponent = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1);
  const value = size / Math.pow(1024, exponent);
  return `${value.toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}
